/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-02 17:27:05
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@root/components/Button';
import Checkbox from '@root/components/Checkbox';
import PageLoading from '@root/components/PageLoading';
import PageLoadError from '@root/components/PageLoadError';
import SafeAreaInset from '@root/components/SafeAreaInset';
import Empty from '@root/components/Empty';
import './index.less';
import useDefaultPackage, {
  TAB_SINGLE,
  TAB_UNLIMITED,
} from '@root/hooks/defaultPackage/useDefaultPackage';
import DefaultPackageCard from '@root/components/DefaultPackageCard';
import { EPayMode } from '@root/constant';

interface IProps {
  payMode?: EPayMode;
}

// /defaultPackage
// /applePay

const DefaultPackage = ({ payMode = EPayMode.PayPal }: IProps) => {
  const { t } = useTranslation();
  const {
    state: { selectedPrice, curPackage, loading, paying, checkedTerm, tab },
    action: {
      onChangeTerm,
      onClickTerm,
      onClickSupplemental,
      onClickAppleAgreement,
      onClickPay,
      fetchPackageData,
      onSelectPrice,
      onChangeTab,
    },
  } = useDefaultPackage({ payMode });

  if (loading < 1) {
    return <PageLoading />;
  }

  if (loading === 2) {
    return <PageLoadError onTryAgain={fetchPackageData} />;
  }

  if (!curPackage.goodsId) {
    return <Empty marginTop={20}>{t('check_products_empty')}</Empty>;
  }

  return (
    <>
      <div className="flex-section-auto default-package-container">
        <DefaultPackageCard
          payMode={payMode}
          goodsName={curPackage.goodsName}
          checkedPriceId={selectedPrice.goodsPriceId}
          goodsPriceList={curPackage.goodsPriceList || []}
          onSelectPrice={onSelectPrice}
          tab={tab}
          onChangeTab={onChangeTab}
          TAB_SINGLE={TAB_SINGLE}
          TAB_UNLIMITED={TAB_UNLIMITED}
        />
        <div className="default-package-checked-term">
          <Checkbox checked={checkedTerm} onChange={onChangeTerm} />
          <div>
            <p className="term-tip neuter600" onClick={onClickTerm}>
              {t('apple-pay-all-agreement')}
            </p>
            <p className="term-tip neuter600" onClick={onClickSupplemental}>
              - {t('apple_pay_plan_terms_conditions')}
            </p>
            {payMode === EPayMode.ApplePay && (
              <p className="term-tip neuter600" onClick={onClickAppleAgreement}>
                - {t('apple-pay-agreement')}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="flex-section-footer">
        <Button loading={paying} disabled={!checkedTerm} onClick={onClickPay}>
          {t('subscribe')}
        </Button>
        <SafeAreaInset />
      </div>
    </>
  );
};

export default DefaultPackage;
